export class CPointer {
    private mcMain:fgui.GComponent;
    private mcPointer:Array<fgui.GMovieClip> = new Array<fgui.GMovieClip>(4);
    private oldDir:number;

    public constructor(doc:fgui.GComponent) {
        this.mcMain = doc;
        this.oldDir = -1;
        for( var i = 0; i < 4; i ++ ) {
            let mc = doc.getChild("mc_Pointer"+i) as fgui.GMovieClip;
            mc.visible = false;
            this.mcPointer[i] = mc;
        }
	}

    public Show(dir:number):void {
        if ( this.oldDir >= 0 ) {
            this.mcPointer[this.oldDir].visible = false;
        }
        if( dir >= 0 ) {
            this.oldDir = dir;
            this.mcPointer[this.oldDir].visible = true;
        }
    }
}